import React from 'react';
import { useTranslation } from 'react-i18next';

import { UploadProgress } from '../../types/file.ts';
import { ProgressBar } from './ProgressBar.tsx';

interface FileUploadProgressProps {
  uploadProgress: UploadProgress | null;
}

export const FileUploadProgress: React.FC<FileUploadProgressProps> = ({ uploadProgress }) => {
  const { t } = useTranslation();

  if (!uploadProgress) {
    return null;
  }

  const overallProgress =
    uploadProgress.totalSize > 0 ? (uploadProgress.uploadedSize / uploadProgress.totalSize) * 100 : 0;

  return <ProgressBar title={t('common.uploading')} overallProgress={overallProgress} />;
};
